import { useContextState } from '../../../../../../hooks/theme'

const useStyles = () => {
  const { colors } = useContextState()

  return {
    tabsContainer: {
      position: 'relative',
      paddingBottom: '20px'
    },
    TabList: {
      width: '100%',
      //paddingRight: '50px',
      '& .MuiTabs-flexContainer': {
        //paddingTop: '5px',
        columnGap: '10px',
        justifyContent: 'end',
        paddingRight: '2px',
      },
      '& .MuiTab-root': {
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
        backgroundColor: `transparent`,
        color: colors.color10,
        '& .MuiTabs-scroller': {
          overflow: 'auto',
        },
        '&.Mui-selected': {
          /* backgroundColor: `${colors.color5}`, */
          color: colors.primary,
          /* boxShadow: `0 0 4px ${colors.color10}`, */
          fontWeight: '600'
        },
      },
      '& .MuiTabs-indicator': {
        backgroundColor: 'transparent',
      },
    },
    TabPanel: {
      '&.MuiTabPanel-root': {
        paddingLeft: '0px',
        paddingRight: '0px',
        paddingTop:1,
        //marginTop:1,
        paddingBottom: '0px',
        //boxShadow: `0 0 4px ${colors.color13}`,
        //borderRadius: '10px',
        width: '100%',
        //minHeight: '55vh'
        // height: '100%',
      },
    },
    titlesTab: { 
        height:'100%', 
        alignContent: 'center',
        fontSize:'20px',
        fontWeight: '500'
    }
  }
}

export { useStyles }
